
export const FETCH_CMSDATA_REQUEST = 'FETCH_CMSDATA_REQUEST';
export const FETCH_CMSDATA_SUCCESS = 'FETCH_CMSDATA_SUCCESS';
export const FETCH_CMSDATA_ERROR = 'FETCH_CMSDATA_ERROR';

export const fetchCMSDataRequest = () => ({
  type: FETCH_CMSDATA_REQUEST,
});

export const fetchCMSDataSuccess = (cmsdatadetail) => ({
  type: FETCH_CMSDATA_SUCCESS,
  payload: cmsdatadetail,
});

export const fetchCMSDataError = (error) => ({
  type: FETCH_CMSDATA_ERROR,
  payload: error,
});
